import script from "./ToastWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToastWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./ToastWrapper.vue?vue&type=style&index=0&id=09168a6a&lang=scss"

const __exports__ = script;

export default __exports__